import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";

import { RootState } from "./types";
import auth from "./modules/auth";
import profile from "./modules/profile";
import event from "./modules/event";
import survey from "./modules/survey";
import shards from "./modules/shards";
import notifications from "./modules/notifications";
import device from "./modules/device";
import resources from "./modules/resources";
import statistics from './modules/statistics';
import testing from './modules/testing';
import app from './modules/app'
import dialog from './modules/dialog'
import locale from './modules/locale'
import style from './modules/style'
import newstatistics from '@/store/modules/newstatistics';
import roistat from './modules/roistat';
import contacts from '@/store/modules/contacts'
import forms from './modules/forms';
import newshards from './modules/newshards';
import statistic_v4 from "@/store/modules/statistic_v4";
import alerts from "@/store/modules/alerts";
import surveys from "@/store/modules/surveys";
import products from "@/store/modules/products";

Vue.use(Vuex);

export const store: StoreOptions<RootState> = {
  modules: {
    style,
    locale,
    auth,
    profile,
    event,
    shards,
    survey,
    notifications,
    device,
    resources,
    statistics,
    testing,
    app,
    dialog,
    newstatistics,
    roistat,
    contacts,
    forms,
    newshards,
    alerts,
    statistic_v4,
    surveys,
    products
  },
};

export default new Vuex.Store<RootState>(store);
